(function(){
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-menu-toggle]');
    if(t){var m=document.querySelector('[data-mobile-menu]');if(m){m.classList.toggle('hidden');m.classList.toggle('xl:hidden');}}
  });
  document.querySelectorAll('[data-product-section]').forEach(function(sec){
    var img=document.getElementById('mainProductImage');
    sec.querySelectorAll('[data-thumb]').forEach(function(b){
      b.addEventListener('click',function(){
        if(img){img.style.opacity='0.3';setTimeout(function(){img.src=b.dataset.full;img.removeAttribute('srcset');img.style.opacity='1';},150);}
        sec.querySelectorAll('[data-thumb]').forEach(function(x){x.classList.remove('border-2','border-primary');x.classList.add('border-primary/30');});
        b.classList.add('border-2','border-primary');b.classList.remove('border-primary/30');
      });
    });
    var q=sec.querySelector('[data-qty]');
    var minus=sec.querySelector('[data-qty-minus]'),plus=sec.querySelector('[data-qty-plus]');
    if(minus)minus.addEventListener('click',function(){q.value=Math.max(1,(parseInt(q.value)||1)-1);});
    if(plus)plus.addEventListener('click',function(){q.value=(parseInt(q.value)||1)+1;});
    var dataEl=sec.querySelector('[data-variants]');
    if(!dataEl)return;
    var variants=JSON.parse(dataEl.textContent);
    var selects=sec.querySelectorAll('[data-option]');
    var idInput=sec.querySelector('[data-variant-id]');
    var price=sec.querySelector('[data-price]');
    var add=sec.querySelector('[data-add]'),label=sec.querySelector('[data-add-label]');
    function money(c){return '$'+(c/100).toFixed(2);}
    function update(){
      var vals=[].map.call(selects,function(s){return s.value;});
      var v=variants.filter(function(x){return vals.every(function(val,i){return x.options[i]===val;});})[0];
      if(!selects.length)return;
      if(v){
        idInput.value=v.id;
        if(price&&window.Shopify&&Shopify.formatMoney){price.textContent=Shopify.formatMoney(v.price);}else if(price){price.textContent=money(v.price);}
        add.disabled=!v.available;label.textContent=v.available?'Add to Cart':'Sold out';
        var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);
      }else{add.disabled=true;label.textContent='Unavailable';}
    }
    selects.forEach(function(s){s.addEventListener('change',update);});
  });
})();
